import { AuthApi } from 'shared/api/requests/auth'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchPages = createAsyncAction('pages/fetchPages', async () => {
  const { data } = await AuthApi.getPages()

  return data.pages
})
